var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
// Components
import { BaseElement } from '@frontend_zz/base-element/BaseElement.js';
// Styling
import styles from './Collapsible.css.js';
// Defs
const cssHeightProp = '--collapsible-max-height';
/**
 * @element zz-collapsible
 */
export class Collapsible extends BaseElement {
    constructor() {
        super(...arguments);
        this.isOpen = false;
        this.open = () => {
            const height = this.scrollHeight;
            this.style.setProperty(cssHeightProp, `${height}px`);
        };
        this.close = () => {
            this.style.setProperty(cssHeightProp, '0');
        };
    }
    static get styles() {
        return [styles];
    }
    connectedCallback() {
        const { isOpen, open, close } = this;
        super.connectedCallback();
        if (isOpen) {
            // Wait for the content to be rendered
            // Note: there's a chance that when this triggers not *everything* in the subtree has rendered — if we run into this, remove the disconnect
            const observer = new ResizeObserver(() => {
                open();
                observer.disconnect();
            });
            observer.observe(this, { box: 'border-box' });
        }
        else {
            close();
        }
    }
    updated(changedProperties) {
        const { isOpen, open, close } = this;
        if (!changedProperties.has('isOpen'))
            return;
        isOpen ? open() : close();
    }
    render() {
        return html `<slot></slot>`;
    }
}
__decorate([
    property({ type: Boolean, attribute: 'is-open' })
], Collapsible.prototype, "isOpen", void 0);
